export const BUSINESS = {
  name: "Milton401 Truck Parts",
  address: "600 Harrop Drive, Milton, Ontario L9T 3H2",
  phoneDisplay: "+1 (647) 292-7121",
  phoneTel: "+16472927121",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent("600 Harrop Drive, Milton, Ontario L9T 3H2"),
};
